import React, {useContext} from 'react';
import Button from '@mui/material/Button';
import {ThemeContext} from "styled-components";

const ButtonIcon = React.forwardRef(({
    children,
    height = { xs: 56, sm: 64 },
    minWidth = '48px',
    baseOpacity = 0.92,
    hoverOpacity = 1,
    pressedOpacity = 0.5,
    color,
    ...props
}, ref) => {

    const theme = useContext(ThemeContext);

    return (
        <Button
            ref={ref}
            variant="unstyled"
            disableRipple
            {...props}
            sx={{
                height,
                minWidth,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 0,
                borderRadius: 0,
                backgroundColor: 'transparent',
                opacity: baseOpacity,
                color: color,
                textAlign: 'center',
                pointerEvents: 'auto',
                position: 'relative',
                zIndex: 1,
                // fontWeight: 900,
                '&:focus': {
                    outline: 'none',
                    backgroundColor: 'transparent',
                },
                '&:focus-visible': {
                    outline: 'none',
                },
                '&:hover': {
                    opacity: hoverOpacity,
                    backgroundColor: 'transparent',
                    '& > *': {
                        transform: 'translate(-0.5px, -0.5px)',
                        transition: 'transform 120ms ease, filter 120ms ease',
                        fontWeight: 900,
                        textShadow: theme.textShadow,
                    },
                },
                '&:active': {
                    opacity: pressedOpacity,
                    transform: 'none',
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                    '& > *': {
                        transform: 'none',
                        filter: 'none',
                    },
                },
                ...props.sx,
            }}
        >
            <span style={{ display: 'inline-block' }}>{children}</span>
        </Button>
    );
});

export default ButtonIcon;
